export default __webpack_public_path__ + "static/bg-flydocs-9d7efb9187e69ab75b423517c1d63262.jpg";